import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, PrinterIcon, ScissorsIcon, PuzzleIcon, InfoIcon } from 'lucide-react';
import { offerings } from '../../data/site';
const icons = {
  book: BookOpenIcon,
  printer: PrinterIcon,
  scissors: ScissorsIcon,
  puzzle: PuzzleIcon
} as const;
const accents = [{
  bar: 'from-brand-cyan to-brand-blue',
  icon: 'bg-brand-cyan/10 text-brand-cyan',
  border: 'hover:border-brand-cyan/40'
}, {
  bar: 'from-brand-blue to-brand-indigo',
  icon: 'bg-brand-blue/10 text-brand-blue',
  border: 'hover:border-brand-blue/40'
}, {
  bar: 'from-brand-indigo to-brand-violet',
  icon: 'bg-brand-indigo/10 text-brand-indigo',
  border: 'hover:border-brand-indigo/40'
}, {
  bar: 'from-brand-violet to-brand-deep',
  icon: 'bg-brand-violet/10 text-brand-violet',
  border: 'hover:border-brand-violet/40'
}];
export function WhatWeOffer() {
  return <section id="what-we-offer" className="w-full bg-white" data-id="element-172" data-mp="3dl4ouy2xmjh9">
      <div className="mx-auto max-w-content px-6 py-24" data-id="element-173" data-mp="3pnulke6bpjjq">
        <div className="max-w-2xl" data-id="element-174" data-mp="3kpt3nwkmvq9u">
          <h2 className="text-3xl font-bold tracking-tight text-navy-800 sm:text-4xl" data-id="element-175" data-mp="3koqd5pr83pug">
            What We Offer
          </h2>
          <span aria-hidden="true" className="mt-4 block h-1 w-16 rounded-full bg-gradient-to-r from-brand-cyan to-brand-violet" data-id="element-176" data-mp="2bab45l37okg" />
          <p className="mt-6 text-lg leading-relaxed text-navy-500" data-id="element-177" data-mp="36p8l91imrwgv">
            Our catalogue is organised into four categories of digital content,
            all created for a general international audience.
          </p>
        </div>

        <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-178" data-mp="3fs007baptad9">
          {offerings.map((item, index) => {
          const Icon = icons[item.icon];
          const accent = accents[index % accents.length];
          return <motion.li key={item.title} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.4,
            delay: index * 0.07
          }} className={`flex h-full flex-col overflow-hidden rounded-2xl border border-navy-100 bg-white transition-colors ${accent.border}`} data-id="element-179" data-mp="q1ms05yb8vn6" data-mpi={index}>
                <span aria-hidden="true" className={`h-1 w-full bg-gradient-to-r ${accent.bar}`} data-id="element-180" data-mp="1n7vg1zt3vva" />
                <div className="flex flex-1 flex-col p-7" data-id="element-181" data-mp="3546ubi7wpott">
                  <span className={`inline-flex h-11 w-11 items-center justify-center rounded-xl ${accent.icon}`} data-id="element-182" data-mp="354q1c3w0qst2">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-183" data-mp="3eujcj3s915ws" />
                  </span>
                  <h3 className="mt-5 text-base font-semibold leading-snug text-navy-800" data-id="element-184" data-mp="2hffb3gcaogt6">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-navy-500" data-id="element-185" data-mp="2mc5p7y4jh2by">
                    {item.description}
                  </p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-10 flex items-start gap-3 rounded-xl border border-brand-violet/20 bg-brand-violet/[0.05] p-5" data-id="element-186" data-mp="29tjujokt84mf">
          <InfoIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-brand-violet" aria-hidden="true" data-id="element-187" data-mp="20uyatq3lqjk2" />
          <p className="text-sm leading-relaxed text-navy-600" data-id="element-188" data-mp="1vwdbdsw6c3wo">
            All products and services offered by Atlas Digital Hub are digital
            products. No physical goods are sold or shipped.
          </p>
        </div>
      </div>
    </section>;
}